import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";

const TextareaAutosizeWidget = ({
  id,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  onBlur,
  onFocus,
  rawErrors = [],
  schema,
  options,
  uiSchema,
}) => {
  const hasError = rawErrors?.length > 0;
  const { rows = 3, maxRows = 6 } = uiSchema["ui:options"] || {};
  const placeholder =  uiSchema["ui:placeholder"];
  return (
    <FormControl fullWidth error={hasError} >
      <TextField
        id={id}
        value={value || ""}
        error={rawErrors?.length > 0}
        onChange={(e) =>
          onChange(e.target.value === "" ? undefined : e.target.value)
        }
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled || readonly}
        required={required}
        label={label}
        multiline
        placeholder={placeholder}
        minRows={rows}
        maxRows={maxRows}
        variant="outlined"
      />
    </FormControl>
  );
};

export default TextareaAutosizeWidget;
